import { withAuthentication } from "@/hoc/withAuthentication";
import React from "react";

const ProtectedImage = ({ user, httpClient, src, loggedInShop, ...props }) => {
  const urlObj = new URL(src, window.location.href);

  urlObj.searchParams.set("authorization", httpClient.getToken()?.access_token);

  return <img src={urlObj.toString()} {...props} />;
};

export default withAuthentication(ProtectedImage);
